export const TOGGLE_DARK_MODE = 'counter/TOGGLE_DARK_MODE';



// WEBPACK FOOTER //
// ./src/redux/constants.js